<fieldset class="field-set dx-theme-border-color">
    <legend class="legend-title">AP Invoice Header Detail</legend>
    <div class="fieldset-container">
        <dx-form width="100%" height="100%" showColonAfterLabel="false" [colCount]="1">
            <dxi-item itemType="group" [colCount]="4">
                <dxi-item>
                    <dxo-label text="Invoice #"></dxo-label>
                    <div *dxTemplate>
                        <app-hyperlink-creator
                            [displayText]="workflowInfo?.invoiceNumber"
                            (onLinkClick)="onInvoiceClick()"
                        ></app-hyperlink-creator>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Invoice Date"></dxo-label>
                    <div *dxTemplate>{{ getFormattedDate(workflowInfo?.invoiceDate) }}</div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Amount To Pay"></dxo-label>
                    <div *dxTemplate>{{ getFormattedCurrency(workflowInfo?.amount) | ccCurrency }}</div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Account #"></dxo-label>
                    <div *dxTemplate>{{ workflowInfo?.vendorAccountNumber }}</div>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" [colCount]="4">
                <dxi-item>
                    <dxo-label text="Due Date"></dxo-label>
                    <div *dxTemplate>{{ getFormattedDate(workflowInfo?.dueDate) }}</div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="GL Post Date"></dxo-label>
                    <div *dxTemplate>{{ getFormattedDate(workflowInfo?.postDate) }}</div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Handling"></dxo-label>
                    <div *dxTemplate>{{ workflowInfo?.specialHandling }}</div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="EFT Account"></dxo-label>
                    <div *dxTemplate>
                        {{ workflowInfo?.isEFTAccount ? 'Yes' : 'No' }}
                    </div>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" [colCount]="4">
                <dxi-item [colSpan]="2">
                    <dxo-label text="Description"></dxo-label>
                    <div *dxTemplate>{{ workflowInfo?.description }}</div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Bank Account"></dxo-label>
                    <div *dxTemplate>{{ workflowInfo?.bankAccount }}</div>
                </dxi-item>
                <dxi-item itemType="empty"></dxi-item>
            </dxi-item>
        </dx-form>
    </div>
</fieldset>

<app-workflow-iva-history
    *ngIf="showInvoiceHistory"
    [communityId]="communityId"
    [payee]="workflowInfo?.payee"
    [workflowId]="workflowInfo?.workflowId"
    [mode]="'invoiceHistory'"
    [title]="'Invoice History'"
    [invoiceHistoryBaseParams]="invoiceHistoryBaseParams"
    (closeIVAHistory)="onCloseHistory()"
></app-workflow-iva-history>
